import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import periodosLetivosService, {
  PeriodosLetivosResponse,
} from "../../../api/periodosLetivos";
import turmasService, { TurmaResponse } from "../../../api/turmas";
import { errorToString } from "../../../helpers/funcoes";

export function Filtros(props: {
  onFilter: (turma: TurmaResponse) => void;
  onError: (error: string) => void;
  disabled?: boolean;
}) {
  const [loadingPeriodo, setLoadingPeriodo] = useState(true);
  const [periodos, setPeriodos] = useState<PeriodosLetivosResponse[]>([]);
  const [periodoSelected, setPeriodoSelected] =
    useState<PeriodosLetivosResponse>();

  const [loadingTurma, setLoadingTurma] = useState(false);
  const [turmas, setTurmas] = useState<TurmaResponse[]>([]);
  const [turmaSelected, setTurmaSelected] = useState<TurmaResponse>();

  useEffect(() => {
    periodosLetivosService
      .getAll()
      .then((periodos) => {
        setPeriodos(periodos);
        if (periodos.length > 0) setPeriodoSelected(periodos[0]);
      })
      .catch((err) => props.onError(errorToString(err)))
      .finally(() => setLoadingPeriodo(false));
  }, []);

  useEffect(() => {
    if (!periodoSelected) return;
    setLoadingTurma(true);
    setTurmaSelected(undefined);
    turmasService
      .getByPeriodo(periodoSelected.id)
      .then((turmas) => {
        setTurmas(turmas);
        if (turmas.length > 0) setTurmaSelected(turmas[0]);
      })
      .catch((err) => props.onError(errorToString(err)))
      .finally(() => setLoadingTurma(false));
  }, [periodoSelected]);

  if (loadingPeriodo) {
    return <Spinner />;
  }
  if (periodos.length == 0) {
    return (
      <Card className="mb-4">
        <CardBody>Nenhum período letivo cadastrado.</CardBody>
      </Card>
    );
  }

  const onPeriodoChanged = (periodoId: string) => {
    setPeriodoSelected(periodos.find((i) => i.id == periodoId));
  };

  const onTurmaChanged = (turmaId: string) => {
    setTurmaSelected(turmas.find((i) => i.id == turmaId));
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <Row>
          <Col sm={3}>
            <Row>
              <Label sm={4} for="cmbPeriodo">
                Período
              </Label>
              <Col sm={8}>
                <Input
                  id="cmbPeriodo"
                  type="select"
                  disabled={loadingTurma}
                  value={periodoSelected?.id}
                  onChange={(e) => onPeriodoChanged(e.target.value)}
                >
                  {periodos.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.nome}
                    </option>
                  ))}
                </Input>
              </Col>
            </Row>
          </Col>
          <Col sm={7}>
            <Row>
              <Label sm={2} for="cmbTurma">
                Turma
              </Label>
              <Col sm={10}>
                {loadingTurma ? (
                  <Spinner />
                ) : turmas.length == 0 ? (
                  "Nenhuma turma foi encontrada."
                ) : (
                  <Input
                    id="cmbTurma"
                    type="select"
                    value={turmaSelected?.id}
                    onChange={(e) => onTurmaChanged(e.target.value)}
                  >
                    {turmas.map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.nome}
                      </option>
                    ))}
                  </Input>
                )}
              </Col>
            </Row>
          </Col>
          {turmaSelected && (
            <Col sm={2} className="mt-3 mt-sm-0">
              <Button
                onClick={() => props.onFilter(turmaSelected)}
                disabled={props.disabled}
              >
                Pesquisar
              </Button>
            </Col>
          )}
        </Row>
      </CardBody>
    </Card>
  );
}
